//#region src/constants/conversation-ratings.ts
var e = {
	AMAZING: 5,
	GREAT: 4,
	OK: 3,
	BAD: 2,
	TERRIBLE: 1
};
//#endregion
export { e as CONVERSATION_RATING_IDS };
